import { User } from "lucide-react";
import { useContent } from "../../i18n/content";
import { SectionHeader } from "../SectionHeader";
import { Reveal } from "../motion/Reveal";

export const Leadership = () => {
    const { ui, site } = useContent();
    return (
    <section data-testid="leadership-section" className="relative py-24 lg:py-32 bg-[#24251f]">
        <div className="max-w-[1440px] mx-auto px-6 lg:px-12">
            <SectionHeader
                chapter={ui.leadership.chapter}
                overline={ui.leadership.overline}
                title={ui.leadership.title}
                description={ui.leadership.description}
            />

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
                {site.leadership.map((p, i) => (
                    <Reveal key={p.role} delay={0.1 * i} className="h-full">
                        <article
                            data-testid={`leader-card-${i}`}
                            className="group h-full border border-[#4a4c42] bg-[#292a24] hover:border-[#f6c422]/60 transition-colors duration-500 flex flex-col"
                        >
                            <div className="relative h-64 bg-[#32332c] flex items-center justify-center overflow-hidden border-b border-[#4a4c42]">
                                <div className="absolute inset-0 section-grid opacity-60" aria-hidden="true" />
                                <div className="relative w-24 h-24 rounded-full border border-[#4a4c42] bg-[#292a24] flex items-center justify-center group-hover:border-[#f6c422]/60 transition-colors duration-500">
                                    <User className="w-10 h-10 text-[#a2a59d] group-hover:text-[#f6c422] transition-colors duration-500" strokeWidth={1.2} />
                                </div>
                                {p.vacant && (
                                    <span className="absolute top-4 right-4 font-display text-[9px] font-bold tracking-[0.2em] uppercase text-[#f6c422] border border-[#f6c422]/40 px-2.5 py-1">
                                        {ui.leadership.openPosition}
                                    </span>
                                )}
                            </div>
                            <div className="p-7 flex flex-col flex-1">
                                <h3 className="font-display text-xl font-extrabold text-white">{p.name}</h3>
                                <p className="overline-text !text-[10px] mt-2">{p.role}</p>
                                <ul className="mt-5 space-y-2 flex-1">
                                    {p.areas.map((a) => (
                                        <li key={a} className="flex items-center gap-3 text-sm text-[#a2a59d]">
                                            <span className="w-1.5 h-1.5 rotate-45 bg-[#f6c422]/70 shrink-0" />
                                            {a}
                                        </li>
                                    ))}
                                </ul>
                                {p.vision && (
                                    <p className="mt-6 pt-5 border-t border-[#4a4c42]/60 text-xs text-[#a2a59d]/80 italic leading-relaxed">
                                        {p.vision}
                                    </p>
                                )}
                            </div>
                        </article>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
    );
};
